<template>
  <template v-if="variant === variants.v1">
    <section class="layout-pt-lg layout-pb-lg" :style="`background-color: var(--c-${vars.backgroundColor})`">
      <div class="container tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-center">
        <div v-html="vars.titleHtml" class="tw-mb-12 lg:tw-mb-14"></div>
        <div class="tw-flex tw-w-full tw-flex-col tw-gap-6 lg:tw-flex-row lg:tw-gap-10 xl:tw-gap-12">
          <div
            v-for="card in cards"
            class="tw-flex tw-flex-1 tw-flex-col tw-gap-6 tw-border tw-p-7"
            style="border-color: var(--c-border)"
          >
            <div class="tw-h-24 tw-w-24">
              <library-image
                :h-ratio="1"
                :w-ratio="1"
                :src="card.icon"
                :alt="card.title"
                image-class="!tw-object-contain"
              />
            </div>
            <h5 :style="`color: var(--c-${vars.textColor})`">{{ card.title }}</h5>
            <p :style="`color: var(--c-${vars.textColor})`">{{ card.description }}</p>
          </div>
        </div>
      </div>
    </section>
  </template>
  <template v-else-if="variant === variants.v2">
    <section class="layout-pt-lg layout-pb-lg" :style="`background-color: var(--c-${vars.backgroundColor})`">
      <div class="container layout-pt-lg md:pt-0">
        <div class="row justify-between items-center">
          <div class="col-auto">
            <div v-html="vars.titleHtml" class="tw-mb-12 lg:tw-mb-14"></div>
          </div>
        </div>

        <div class="tw-grid tw-grid-cols-12 tw-gap-6">
          <div
            v-for="card in cards"
            class="tw-col-span-12 tw-flex tw-flex-1 tw-flex-col tw-gap-6 tw-border tw-p-7 lg:tw-col-span-6"
            style="border-color: var(--c-border)"
          >
            <div class="tw-h-24 tw-w-24">
              <library-image
                :h-ratio="1"
                :w-ratio="1"
                :src="card.icon"
                :alt="card.title"
                image-class="!tw-object-contain"
              />
            </div>
            <h5 :style="`color: var(--c-${vars.textColor})`">{{ card.title }}</h5>
            <p :style="`color: var(--c-${vars.textColor})`">{{ card.description }}</p>
          </div>
        </div>
      </div>
    </section>
  </template>

  <template v-else-if="variant === variants.v3">
    <section class="layout-pt-lg layout-pb-lg" :style="`background-color: var(--c-${vars.backgroundColor})`">
      <div class="container">
        <div class="d-block d-lg-none tw-mb-8">
          <h2 class="font-semibold tw-text-3xl lg:tw-text-4xl">
            {{ vars.titleText }}
          </h2>
          <p class="tw-mt-6">{{ vars.descriptionText }}</p>
        </div>

        <!-- Mobilde: sadece slider -->
        <div class="d-block d-lg-none">
          <Swiper
            :modules="[SwiperPagination]"
            @slideChange="onSlideChange"
            :pagination="false"
            :space-between="16"
            :loop="true"
            effect="fade"
            :clickable="true"
            :breakpoints="{ 320: { slidesPerView: 1 } }"
            @swiper="onSwiper"
            class="tw-w-full"
          >
            <SwiperSlide
              v-for="card in cards"
              :key="card.title"
              class="tw-border tw-p-7"
              style="border-color: var(--c-border)"
            >
              <div class="tw-h-24 tw-w-24">
                <library-image
                  :h-ratio="1"
                  :w-ratio="1"
                  :src="card.icon"
                  :alt="card.title"
                  image-class="!tw-object-contain"
                />
              </div>
              <h5 class="tw-mt-4">{{ card.title }}</h5>
              <p class="tw-mt-2">{{ card.description }}</p>
            </SwiperSlide>
          </Swiper>
        </div>
        <div class="d-flex d-lg-none justify-content-start mb-4">
          <LibrarySliderPagination
            :swiper="swiper"
            variant="v10"
            :can-paginate-back="canPaginateBack"
            :can-paginate-next="canPaginateNext"
            :variables="vars"
          />
        </div>

        <!-- Masaüstü: 2 sütunlu grid -->
        <div class="d-none d-lg-grid tw-grid tw-grid-cols-2 tw-gap-6">
          <!-- 1. hücre: Başlık & Açıklama (grid içindeki) -->
          <div class="tw-p-7">
            <h2 class="font-semibold tw-text-3xl">
              {{ vars.titleText }}
            </h2>
            <p class="tw-mt-12">{{ vars.descriptionText }}</p>
          </div>

          <!-- 2. hücre: İlk kart (Energy…) -->
          <div v-if="cards[0]" class="tw-border tw-p-7" style="border-color: var(--c-border)">
            <div class="tw-h-24 tw-w-24">
              <library-image
                :h-ratio="1"
                :w-ratio="1"
                :src="cards[0].icon"
                :alt="cards[0].title"
                image-class="!tw-object-contain"
              />
            </div>
            <h4 class="tw-mt-4">{{ cards[0].title }}</h4>
            <p class="tw-mt-2">{{ cards[0].description }}</p>
          </div>

          <!-- Geride kalan kartlar -->
          <div
            v-for="card in cards.slice(1)"
            :key="card.title"
            class="tw-border tw-p-7"
            style="border-color: var(--c-border)"
          >
            <div class="tw-h-24 tw-w-24">
              <library-image
                :h-ratio="1"
                :w-ratio="1"
                :src="card.icon"
                :alt="card.title"
                image-class="!tw-object-contain"
              />
            </div>
            <h4 class="tw-mt-4">{{ card.title }}</h4>
            <p class="tw-mt-2">{{ card.description }}</p>
          </div>
        </div>
      </div>
    </section>
  </template>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import { produceKey } from '~/server/core/helpers';
import { jQuery } from 'public/theme3/js/custom';

export default defineNuxtComponent({
  name: 'OurValues',
  mixins: [ComponentMixin],

  data() {
    return {
      variants: {
        v1: 'v1',
        v2: 'v2',
        v3: 'v3',
      },
      isPopupVisible: false,
      visibleIndex: 0,
      swiper: null,
      canPaginateBack: true,
      canPaginateNext: true,
      renderKey: produceKey(),
    };
  },

  mounted() {
    this.onSlideChange();
  },

  computed: {
    visibleTestimonial() {
      return this.items[this.visibleIndex];
    },

    cards() {
      return this.groupedVariables.cards;
    },
  },

  methods: {
    togglePopup(status = false) {
      this.isPopupVisible = status;
    },

    goNextOne() {
      if (this.items.length !== this.visibleIndex + 1) {
        this.visibleIndex += 1;
      } else {
        this.visibleIndex = 0;
      }
      this.renderKey = produceKey();
      this.$nextTick(() => {
        jQuery.runAnimation();
      });
    },

    goPrevOne() {
      if (this.visibleIndex > 0) {
        this.visibleIndex -= 1;
      } else {
        this.visibleIndex = this.items.length - 1;
      }
      this.renderKey = produceKey();
      this.$nextTick(() => {
        jQuery.runAnimation();
      });
    },

    onSwiper(swiper) {
      this.swiper = swiper;
    },
    onSlideChange() {
      if (!this.swiper) return;
      const isAtStart = this.swiper.isBeginning;
      const isAtEnd = this.swiper.isEnd;
      if (isAtStart) this.canPaginateBack = false;
      else this.canPaginateBack = true;
      if (isAtEnd) this.canPaginateNext = false;
      else this.canPaginateNext = true;
    },
  },
});
</script>
